import { render } from "./personal-info-graph.vue?vue&type=template&id=5dd547c8&lang=true"
import script from "./personal-info-graph.vue?vue&type=script&lang=js"
export * from "./personal-info-graph.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__